import { ImageBackgroundContainer, ImageBackgroundFill, ImageBackgroundImage } from './ImageBackground.styled'

type ImageBackgroundProps = {
  backgroundColor?: string
  gridColumns?: string
  image: string
  imagePosition?: string
}

const ImageBackground = ({ backgroundColor, gridColumns, image, imagePosition }: ImageBackgroundProps) => {
  return (
    <ImageBackgroundContainer gridColumns={gridColumns ?? 'repeat(2, 1fr)'}>
      <ImageBackgroundFill backgroundColor={backgroundColor ?? '#FFF'} />
      <ImageBackgroundImage src={image} imagePosition={imagePosition} />
    </ImageBackgroundContainer>
  )
}

export type { ImageBackgroundProps }
export { ImageBackground }
